










































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {i18nMixin} from '@/modules/neodash/mixins';
import {Store, StoreHistoryHierarchy} from '@/modules/business-plan/modules/approval/pages/volvo-goal-settings/types';
import {storeStatus} from '@/modules/business-plan/modules/models/enums/storeStatus';

@Component({
  name: 'TableDialogStore'
})
export default class TableDialogStore extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  public readonly storeStatus = storeStatus;

  @Prop({required: true})
  public stores: StoreHistoryHierarchy[];

  @Prop({required: true})
  public textTitle: string;

  @Prop({required: true})
  public show: boolean;

  public create() {
    console.log(this.stores);
  }

  public sumBy(getProp) {
    return this.stores.reduce((res, acc) => {
      return res += getProp(acc);
    }, 0);
  }

  private toggleInfoModal() {
    this.$emit('toggleModal');
  }
}
